<template>
  <header id="header">
    <div class="logo" v-if="isHeaderLogo == true"></div>
    <div class="btn-left" v-if="isHeaderBtn == true">
      <button type="" class="btn-pre" @click="goBack">
        <div class="icon icons-left"></div>
      </button>
    </div>
    <div class="btn-right" v-if="isHeaderBtn == true">
      <button type="" class="btn-home" @click="clickBtnHome">
        <div class="icon icons-home"></div>
      </button>
    </div>
    <div class="survey-title" v-if="isHeaderSurvey == true">
      상담센터 만족도 조사
    </div>
    <div class="survey-intro" v-if="isHeaderSurvey == true">
      안녕하십니까?
      <br />
      한국장학재단은 상담서비스 개선과
      <br />
      고객 만족도 향상을 위해
      <br />
      설문조사를 진행하고 있습니다.
      <br />
      고객님의 소중한 의견 부탁드립니다.
    </div>
    <div class="h-notice" v-if="isHeaderNoti == true && getNotice != null">
      <a
        href="#"
        class="btn-text"
        v-html="this.$Util.removeTag(this.$Util.replaceTag(getNotice))"
      >
      </a>
      <button type="button" class="btn" @click="clickBtnMore">더보기</button>
    </div>
  </header>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState("manageUI", {
      isHeaderLogo: state => state.isHeaderLogo,
      isHeaderNoti: state => state.isHeaderNoti,
      isHeaderSurvey: state => state.isHeaderSurvey,
      isHeaderBtn: state => state.isHeaderBtn
    }),
    ...mapState("system", {
      getNotice: state => state.notice
    })
  },
  methods: {
    goBack() {
      //this.$router.go(-1)
      //comApi.goBack();
      this.$goBack();
    },
    clickBtnHome() {
      this.$go("VARS00101");
    },
    clickBtnMore() {
      this.$alert({
        title: "공지사항",
        contents: this.$Util.replaceTag(this.getNotice),
        btn_type: this.$CONST.BTN_TP_OK
      });
    }
  }
};
</script>
